import {
  CSSProperties,
  forwardRef,
  ForwardRefRenderFunction,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'

import { Input, Text, theme, UserAvatar } from '@hhgtech/hhg-components'
// import { DISCOVER_PATHS } from 'api/paths'
// import { CommunityButton } from 'components/atoms/communityButton'
// import { UserAvatar } from 'components/atoms/userAvatar'
import { DISCOVER_PATHS } from 'api/paths'
// import { StyledUserAvatar } from 'components/atoms/userAvatar/index.styled'
// import { MobileCommentTriggerContext } from 'components/pages/post'
import { DEFAULT_AVATAR_IMG, ENV } from 'interfaces/constants'
import { UserInfo } from 'interfaces/types'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'
import { AppContext } from 'state/appContext'

import { EditorProviderProps } from '../../../molecules/editor'
import { EditorProps } from '../../../molecules/editor/editorContainer'
import { ErrorProps } from '../../../molecules/editor/error'
import { PreviewCardProps } from '../../../molecules/editor/previewCard'
import { AttachImageType } from '../../../molecules/editor/types'
import Send from '../icons/Send'
import { Comment, Post } from '../interfaces/types'
import {
  getCommentFormBody,
  submitComment,
  submitReply,
  updateComment,
} from '../utils/commentHelper'
import { formatComment } from '../utils/dataTransform'
import { uploadAndGetSrc } from '../utils/post'
// import { ExpandPopup } from './expandPopup'
import { ExpandPopup } from './expandPopup'
import {
  StyledActions,
  StyledBtnText,
  StyledColLeft,
  StyledColRight,
  StyledCommunityButton,
  StyledInputCommentBar,
  StyledRichTextWRapper,
  StyledRow,
} from './index.styled'

const RichTextProvider = dynamic<EditorProviderProps>(
  () => import('../../../molecules/editor').then((mod) => mod.RichTextProvider),
  {
    loading: () => null,
    ssr: false,
  },
)

const RichTextEditor = dynamic<EditorProps>(
  () =>
    import('../../../molecules/editor').then(
      (mod) => mod.RichTextProvider.Editor,
    ),
  {
    loading: () => null,
    ssr: false,
  },
)

const PreviewCard = dynamic<PreviewCardProps>(
  () =>
    import('../../../molecules/editor').then(
      (mod) => mod.RichTextProvider.PreviewCard,
    ),
  {
    loading: () => null,
    ssr: false,
  },
)

const Error = dynamic<ErrorProps>(
  () =>
    import('../../../molecules/editor').then(
      (mod) => mod.RichTextProvider.Error,
    ),
  {
    loading: () => null,
    ssr: false,
  },
)

const CountCharater = dynamic<ErrorProps>(
  () =>
    import('../../../molecules/editor').then(
      (mod) => mod.RichTextProvider.CountCharater,
    ),
  {
    loading: () => null,
    ssr: false,
  },
)

export type Props = {
  className?: string
  onClose?: () => void
  replyToName?: string
  replyToUrl?: string
  replyingId?: string
  replyingUser?: UserInfo
  replyingUserExpertId?: string
  style?: CSSProperties
  onPostSuccess?: (c: Comment) => void
  onPopupClose?: () => void
  isMainCmt?: boolean
  post?: Post
  isReply?: boolean
  btnProps?: any
  isEdit?: boolean
  commentId?: string
  expandPopupProps?: any
  imageFiles?: AttachImageType
  isMobile?: boolean
  value?: string
  showFullEditor?: boolean
  invalidValue?: boolean
  btnLabel?: string
  headerTitle?: string
}

export type HandleProps = {
  focusEditor: () => void
  setValue: (v: string) => void
}

export const InputCommentBar = forwardRef(function InputCommentBar(
  {
    isReply,
    className,
    onClose,
    replyToName,
    style,
    replyingId,
    replyingUser,
    onPostSuccess,
    // onPopupClose,
    // isMainCmt = false,
    post,
    btnProps,
    isEdit,
    commentId = '',
    expandPopupProps,
    imageFiles: imageFilesProps,
    isMobile,
    value = '',
    showFullEditor,
    btnLabel: btnLabelProps,
    headerTitle,
  },
  ref,
) {
  const { NEXT_PUBLIC_SSO: SSO_URL } = ENV
  const { formatMessage: f } = useIntl()
  const { locale = 'vi-VN' } = useRouter()
  const [text, setText] = useState<string>(value)
  const { pushNotifications, state } = useContext(AppContext)
  const { userInfo } = state
  // const { trigger } = useContext(MobileCommentTriggerContext)
  const [isSubmitLoading, setIsSubmitLoading] = useState<boolean>(false)

  const contentEditable = useRef<HTMLElement | null>(null)
  const mainInput = useRef<HTMLDivElement>(null)

  const [bannedWords, setBannedWords] = useState<string[]>([])
  const [imageFiles, setImageFiles] = useState<any>(imageFilesProps || [])
  const [invalidValue, setInvalidValue] = useState(false)
  const [previewUrl, setPreviewUrl] = useState<{
    title?: string
    url?: string
    image?: string
    rawUrl?: string
    description?: string
    isFetching?: boolean
  } | null>(null)
  const [expandPopup, setExpandPopup] = useState(false)

  const onSubmitComment = async () => {
    if (!post?.id || isSubmitLoading) return
    setIsSubmitLoading(true)
    try {
      const handleSuccess = (res: any) => {
        setText('')
        // onRemoveAllImages()
        onClose && onClose()
        const newComment = formatComment(res.data)
        if (typeof newComment.images === 'string') {
          newComment.images = JSON.parse(newComment.images)
        }
        setExpandPopup(false)
        onPostSuccess?.(newComment)
      }
      const uploadedImageFiles = await Promise.all(
        imageFiles.map(
          (file: File, index: number) =>
            new Promise<string>((resolve) =>
              setTimeout(
                () => resolve(uploadAndGetSrc(file, locale)),
                2000 * index,
              ),
            ),
        ),
      )
      setImageFiles(uploadedImageFiles)
      const formBody = await getCommentFormBody({
        message: text,
        photos: imageFiles as File[],
        postId: post.id,
        link: previewUrl?.url,
        locale,
        ...(isReply && replyingId
          ? {
              replyingUserId: String(
                replyingUser?.id || post?.author?.id || '',
              ),
              replyingId,
              replyingUserName:
                replyingUser?.name || replyingUser?.username || '',
            }
          : {}),
      })
      const res = await (isEdit
        ? updateComment(commentId, formBody, locale)
        : isReply && replyingId
        ? submitReply(formBody, locale)
        : submitComment(formBody, locale))
      const resData = res?.data
      if (resData?.id && !res?.messages?.moderation?.type) {
        handleSuccess(res)
      } else {
        if (res?.messages?.moderation?.type === 'banned') {
          pushNotifications({
            title: f({
              id: 'notification.comment.blocked.title',
            }),
            message: f({
              id: 'notification.comment.blocked.message',
            }),
            type: 'danger',
          })
          if (res.messages.moderation.words) {
            setBannedWords(res.messages.moderation.words)
          }
        } else if (res?.messages?.moderation?.type === 'suspect') {
          pushNotifications({
            title: f({ id: 'notification.comment.suspect.title' }),
            message: f({ id: 'notification.comment.suspect.message' }),
            type: 'warning',
          })
          setText('')
          // onRemoveAllImages?.()
          onClose && onClose()
        } else if (
          res?.messages?.find((m: string) => !!m?.includes?.('suspend'))
        ) {
          pushNotifications({
            message: f({ id: 'notification.suspend.message' }),
            type: 'warning',
          })
          setText('')
          // onRemoveAllImages?.()
          onClose && onClose()
        } else {
          pushNotifications({
            title: '',
            message:
              res?.messages?.[0] ||
              f({ id: 'notification.comment.somethingWrong' }),
            type: 'danger',
          })
        }
      }
    } catch (e) {
      console.error(e)
      pushNotifications({
        title: '',
        message: f({ id: 'notification.comment.somethingWrong' }),
        type: 'danger',
      })
    }
    setIsSubmitLoading(false)
  }

  const focusEditor = () => {
    contentEditable.current?.focus()
  }

  const handleSetValue = (val: string) => {
    setText(val)
  }

  useImperativeHandle(ref, () => ({
    focusEditor,
    setValue: handleSetValue,
  }))

  // useEffect(() => {
  //   focusEditor()
  // }, [trigger])

  useEffect(() => {
    setText(value)
  }, [value])

  useEffect(() => {
    return () => setExpandPopup(false)
  }, [])

  const hasHeaderLayout = isEdit || isReply
  const btnLabel =
    btnLabelProps ||
    (isEdit
      ? 'Update'
      : isReply
      ? f({ id: 'cardReactions.reply' })
      : f({ id: 'cardReactions.comment' }))

  const commonBtnProps = {
    // isLoading: isSubmitLoading,
    isDisabled:
      invalidValue ||
      isSubmitLoading ||
      !text ||
      text?.length < 2 ||
      !text.trim(),
  }

  const defaultTitle = isEdit
    ? isReply
      ? f({
          id: 'inputComment.updateReply',
          defaultMessage: 'Edit reply',
        })
      : f({
          id: 'inputComment.updateComment',
          defaultMessage: 'Edit comment',
        })
    : f(
        {
          id: 'inputComment.replyTo',
        },
        {
          name: `<span style="color: #2D87F3; cursor: pointer">@${
            replyToName || ''
          }</span>`,
        },
      )

  const editor = (
    <RichTextProvider
      imageFiles={imageFiles}
      value={text}
      onChange={setText}
      onImageFilesChange={setImageFiles}
      bannedWords={bannedWords}
      onPreviewUrlChange={setPreviewUrl}
      // onInvalidUrlsChange={setInvalidUrls}
      // setEditorRef={(div) => (contentEditable.current = div)}
      isReplying={isReply}
      hasEmbbedSocialLink={false}
      hasExpandToolbar={showFullEditor ? !showFullEditor : isMobile}
      hasExpandPopup={!showFullEditor}
      onInitEditor={(ref) => (contentEditable.current = ref)}
      onInvalidVal={setInvalidValue}
    >
      <StyledInputCommentBar
        data-is-input-style={!showFullEditor}
        data-is-reply={isReply}
        className={className}
        style={style}
      >
        {hasHeaderLayout && !showFullEditor && (
          <StyledRow>
            <StyledColLeft>&nbsp;</StyledColLeft>
            <StyledColRight>
              <div className="reply-to-container">
                <Text size="p4">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: headerTitle || defaultTitle,
                    }}
                  />
                </Text>
                <img
                  loading="lazy"
                  src={'./svg/icon-close-circle-line.svg'}
                  className="icon-close-comment"
                  onClick={() => onClose && onClose()}
                  alt=""
                />
              </div>
            </StyledColRight>
          </StyledRow>
        )}
        <div className="input-container" ref={mainInput}>
          {!showFullEditor && (
            <a
              href={SSO_URL + DISCOVER_PATHS.GET_PROFILE}
              style={{ textDecoration: 'none' }}
            >
              <UserAvatar
                style={{ textDecoration: 'none' }}
                className={`avatar-wrapper ${
                  isReply ? 'avatar-wrapper-reply' : ''
                }`}
                avatar={userInfo?.id ? userInfo.avatar : DEFAULT_AVATAR_IMG}
                username={userInfo?.name || userInfo?.username}
              />
            </a>
          )}
          <Input
            value={text}
            name="input"
            size="md"
            className="input-wrapper"
            CustomInput={
              <div className="as-input">
                <StyledRichTextWRapper>
                  <RichTextEditor
                    className="textarea"
                    toolbarStyle={{
                      ...(!showFullEditor && {
                        borderBottom: 0,
                      }),
                      ...(showFullEditor && {
                        borderTopLeftRadius: 6,
                        borderTopRightRadius: 6,
                        border: `1px solid ${theme.colors.gray200}`,
                      }),
                    }}
                    textareaStyle={{
                      ...(showFullEditor && {
                        border: `1px solid ${theme.colors.gray200}`,
                        borderTop: 0,
                        minHeight: 155,
                      }),
                    }}
                    expandPopupHandler={() => setExpandPopup(!expandPopup)}
                  />
                </StyledRichTextWRapper>
                {showFullEditor && <CountCharater />}
                <StyledActions
                  style={{
                    ...(showFullEditor && {
                      justifyContent: 'flex-end',
                      marginTop: '10px',
                    }),
                  }}
                >
                  <StyledCommunityButton
                    className="send-button"
                    size="sm"
                    onClick={onSubmitComment}
                    {...commonBtnProps}
                    {...btnProps}
                    theme={'marryBaby'}
                  >
                    {!showFullEditor ? (
                      <Send
                        className="icon-enter"
                        color={theme.colors.primaryBase}
                      />
                    ) : (
                      <StyledBtnText>{btnLabel}</StyledBtnText>
                    )}
                  </StyledCommunityButton>
                </StyledActions>
              </div>
            }
          />
        </div>
        <Error />
        <PreviewCard />
      </StyledInputCommentBar>
    </RichTextProvider>
  )

  return (
    <>
      {editor}
      {expandPopup && (
        <ExpandPopup
          heading={defaultTitle}
          onClose={() => {
            setExpandPopup(false)
          }}
          onPostSuccess={onPostSuccess}
          imageFiles={imageFiles}
          btnLabel={btnLabel}
          value={text}
          bannedWords={bannedWords}
          post={post}
          isMobile={isMobile}
          isEdit={isEdit}
          isReply={isReply}
          commentId={commentId}
          {...expandPopupProps}
        />
      )}
    </>
  )
} as ForwardRefRenderFunction<HandleProps, Props>)
